import { render } from "./ItemInfo.vue?vue&type=template&id=2f327602&scoped=true"
import script from "./ItemInfo.vue?vue&type=script&lang=js"
export * from "./ItemInfo.vue?vue&type=script&lang=js"

import "./ItemInfo.vue?vue&type=style&index=0&id=2f327602&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f327602"]])

export default __exports__